import { useEffect, useState } from 'react';
import { Paper, Button, Table, TableBody, Grid } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ReconcileInvoiceList from '../components/ReconcileInvoiceList';
import ReconcileBatchCRU from '../components/ReconcileBatchCRU';
import ReconcileInvoiceHD from '../components/ReconcileInvoiceHD';
import { DeletePopUp, NoRecordFound, PageLoader, Pagination, STableLoader } from '../../../shared_elements';
import { LeasesBasicDetails, LeasesMenuList, LeasesNav } from '../../elements';
import { globalDeleteService, globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { ButtonLoader } from '../../../shared_elements/components';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory';
import { trackActivity } from '../../../utils/mixpanel';
import { deleteReconcileBatchApi, getReconcileInvoiceApi } from '../apiService';
import { PermissionWrapper } from '../../../wrappers';
import BackToLeaseList from '../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { RoleBaseAccess } from '../../../hoc';

const TABLE_HEIGHT = 'calc(100vh - 185px)';

const ReconcileInvoice = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { leaseSlug } = useParams();
    const params = { leaseSlug };
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false);
    const [deleteReconcileBatch, setDeleteReconcileBatch] = useState({ modal: false, data: null });
    const [addEditReconcileBatch, setAddEditReconcileBatch] = useState({ mode: '', modal: false, data: null });
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [reconcileInvoiceInfo, setReconcileInvoiceInfo] = useState({ pagination: {} });
    const [isExport, setIsExport] = useState(false)
    const { leaseBasicDetails } = useSelector((state) => state.leases);

    useEffect(() => {
        if (!leaseBasicDetails) return;
        if (leaseBasicDetails?.status === "Draft") return;
        getReconcileInvoiceList('skeletonLoader', { per_page: 50, });
    }, []);

    useEffect(() => {
        trackActivity("Page Viewed", { page_title: "Reconcile Invoices" });
    }, []);

    const getReconcileInvoiceList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);

        globalGetService(getReconcileInvoiceApi(params, query), {}).then(response => {
            if (checkApiStatus(response)) {
                setReconcileInvoiceInfo(response.data.data);
            }
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
        });
    };

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] })
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const ondeleteReconcileBatch = () => {
        setLoading(true);
        const idsToDelete = bulk?.modal ? (bulk?.ids || []).map(item => item?.id) : [deleteReconcileBatch?.data?.id];
        globalDeleteService(deleteReconcileBatchApi(params), { ids: idsToDelete })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Reconcile Batch`, success_msg: response?.data?.message, item_ids: deleteReconcileBatch?.data || bulk?.ids, response: response?.data })
                    setDeleteReconcileBatch({ modal: false, data: null });
                    getReconcileInvoiceList('', { page: reconcileInvoiceInfo?.pagination?.current_page || 1, per_page: reconcileInvoiceInfo?.pagination?.per_page || 20 });
                    setBulk({ modal: false, ids: [], title: '', type: '' });
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Reconcile Batch`, error_msg: response?.data?.message, item_ids: deleteReconcileBatch?.data || bulk?.ids, response: response?.data })
                }
            });
    };

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key }
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getReconcileInvoiceList('', {
            ...sortQuery,
            page: reconcileInvoiceInfo?.pagination?.current_page || 1,
            per_page: reconcileInvoiceInfo?.pagination?.per_page || 20,
        });
    }

    const handleExport = () => {
        // seIsExport(true);
        // globalGetService(getReconcileInvoiceApi( params, { export: true})).then((response)=>{
        //     if (checkApiStatus(response)){
        //       enqueueSnackbar(
        //              response?.data.message,
        //              { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
        //            );
        //             seIsExport(false);
        //     }
        // })
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Reconcile Invoice`, page_type: page_type, })
    }

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
                <LeasesNav />
                {leaseBasicDetails?.status === "Draft" ? (<ModuleNotExcessModal moduleName="Reconcile Invoices" />) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
                <div className='lease-details-content'>
                    <Paper square className="responsive-paper">
                        <Grid container spacing={1} className="responsive-grid" alignItems="end">
                            <Grid item size={{ md: 4, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 8, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'0px', float:'right'}}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} /></li>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['D'] }}>
                                                        <li className='lease-mobile-button'>
                                                            <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                                                        </li>
                                                    </PermissionWrapper>
                                            </> : null
                                    }
                                    {reconcileInvoiceInfo?.list?.length > 0 ? <li className='lease-mobile-button'>
                                        {/* <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} variant="outlined" size='small' onClick={() => { handleExport("xlsx"); handleItemClicked('Export Button') }}> Export </Button> */}
                                    </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['C'] }}>
                                    <li className='lease-mobile-button'>
                                        <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' size="small" variant="contained" disabled={skeletonLoader} color="primary" onClick={() => { setAddEditReconcileBatch({ modal: true, data: null, mode: 'add', }); handleItemClicked('Add Item Button') }}> Add Reconcile Invoices </Button>   
                                    </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper className='lease-detail-table lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: reconcileInvoiceInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                        <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                            {skeletonLoader ? <STableLoader count={6} rowCount={11} /> : (
                                <Table className='mui-table-format' stickyHeader>
                                    <ReconcileInvoiceHD item={reconcileInvoiceInfo?.list} toggleBulkOps={toggleBulkOps} bulk={bulk} createSortHandler={createSortHandler} sortInfo={sortInfo} />
                                    <TableBody>
                                        {reconcileInvoiceInfo?.list?.length > 0 && reconcileInvoiceInfo?.list?.map((item, index) => {
                                            return (
                                                <ReconcileInvoiceList
                                                    deleteReconcileBatch={deleteReconcileBatch}
                                                    key={index}
                                                    item={item}
                                                    bulk={bulk}
                                                    addEditReconcileBatch={addEditReconcileBatch}
                                                    viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                    onEdit={() => setAddEditReconcileBatch({ modal: true, mode: 'edit', data: item })}
                                                    onDelete={() => {
                                                        setDeleteReconcileBatch({ modal: true, data: item });
                                                        setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                    }}
                                                    onView={() => navigate(`/lease/${leaseSlug}/reconcile-invoices-view/${item.slug}`)}
                                                    toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                                                />
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            )}
                            {!skeletonLoader && !reconcileInvoiceInfo?.list?.length && <NoRecordFound />}
                        </div>
                        <Paper>
                            <Pagination
                                pagination={reconcileInvoiceInfo?.pagination}
                                onPageChange={(event, newPage) => { const pageNum = newPage + 1; getReconcileInvoiceList('pageLoader', { page: pageNum, per_page: reconcileInvoiceInfo?.pagination?.per_page || 10, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
                                onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getReconcileInvoiceList('pageLoader', { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
                            />
                        </Paper>
                    </Paper>
                </div>}
            </Paper>
            {
                addEditReconcileBatch.modal && <ReconcileBatchCRU
                    params={params}
                    addEditReconcileBatch={addEditReconcileBatch}
                    modeType={addEditReconcileBatch.mode}
                    addEditSupplement={addEditReconcileBatch}
                    getResponseBack={() => {getReconcileInvoiceList('pageLoader', { page: reconcileInvoiceInfo?.pagination?.current_page || 1, per_page: reconcileInvoiceInfo?.pagination?.per_page || 20 }); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    onToggleModal={() => setAddEditReconcileBatch({ modal: false, mode: '', data: null })}
                />
            }

            {deleteReconcileBatch.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deleteReconcileBatch.modal}
                    title={bulk?.modal ? (bulk?.ids?.length > 0 && bulk?.ids?.length === (reconcileInvoiceInfo?.list?.length || 0)) ? "Delete All Reconcile Batches" : "Delete Selected Reconcile Batch" : "Delete Reconcile Batch"}
                    onDeleteRecords={() => ondeleteReconcileBatch()}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids?.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        if (bulk.modal) {
                            setBulk({ modal: false, ids: [], title: '', type: '' });
                        } else {
                            setDeleteReconcileBatch({ modal: false, data: null });
                            setBulk({ modal: false, ids: [], title: '', type: '' });
                        }
                    }}
                /> : null}

            {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"reconcile_invoice_batch"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }

            {isLoading ? <PageLoader /> : null}
        </>
    )
}

export default RoleBaseAccess(ReconcileInvoice, { application: 'lease_revamp', feature: 'invoices', operationType: ['R'], leaseNav: true });

